"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EditIcon;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } // Generated by build-icons
// Do not edit by hand!
// @hash ed9ede378c1d8cb8b6082b75cd8fc6bc24497c39
const svgElement = /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M73.73 20.35L41.55 52.53a2 2 0 0 0-.55 1.13l-2.28 16a2 2 0 0 0 2 2.28h.25l16.25-2a2 2 0 0 0 1.17-.57l32.14-32.22a11.88 11.88 0 1 0-16.8-16.8zM56 66l-13 1.62 1.82-12.74L72.63 27.1l11.15 11.15zm31.7-31.68l-1.1 1.1-11.14-11.14 1.1-1.1A7.88 7.88 0 0 1 87.7 34.32zM6 10.5a2 2 0 0 0 2 2h64a2 2 0 1 0 0-4H8a2 2 0 0 0-2 2zM8 32.25h44a2 2 0 0 0 0-4H8a2 2 0 1 0 0 4zM8 52h24a2 2 0 0 0 0-4H8a2 2 0 0 0 0 4zM8 71.75h24a2 2 0 0 0 0-4H8a2 2 0 1 0 0 4zM8 91.5h64a2 2 0 0 0 0-4H8a2 2 0 1 0 0 4z"
}));
function EditIcon(props) {
  return /*#__PURE__*/_react.default.createElement("span", _extends({
    className: "icon icon-edit"
  }, props), svgElement);
}